import { render } from "./DeleteOutline.vue?vue&type=template&id=2668dfba"
import script from "./DeleteOutline.vue?vue&type=script&lang=js"
export * from "./DeleteOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__